/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-writings.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/intl.service';
import * as import10 from '../shared/meta.service';
import * as import11 from '../shared/utils.service';
import * as import12 from '../shared/content.service';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '@angular/common/src/location/location';
import * as import15 from '@angular/router/src/router';
import * as import16 from '@angular/core/src/metadata/view';
import * as import17 from '@angular/core/src/linker/component_factory';
import * as import18 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import19 from '../shared/searchable-contents.component.ngfactory';
import * as import20 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import21 from '../shared/intl.pipe';
import * as import22 from '@angular/common/src/pipes/date_pipe';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '../shared/search.service';
import * as import25 from '../shared/search-elasticsearch.service';
import * as import26 from '@angular/core/src/i18n/tokens';
import * as import27 from '@angular/common/src/directives/ng_if';
import * as import28 from '@angular/common/src/directives/ng_switch';
import * as import29 from '../shared/searchable-contents.component';
import * as import30 from '../shared/loading-indicator.ngfactory';
import * as import31 from '../shared/loading-indicator';
import * as import32 from './search-facets.component.ngfactory';
import * as import33 from './search-facets.component';
import * as import34 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import35 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import36 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import37 from '@angular/core/src/linker/element_ref';
import * as import38 from '@angular/common/src/directives/ng_class';
import * as import39 from '../shared/search-filter.component.ngfactory';
import * as import40 from '../shared/search-filter.component';
import * as import41 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import42 from '@angular/common/src/directives/ng_for';
import * as import43 from '../../../node_modules/ng2-bs-pagination/src/pagination.component.ngfactory';
import * as import44 from 'ng2-bs-pagination/src/pagination.component';
export class Wrapper_ContentWritingsComponent {
  context:import0.ContentWritingsComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this.changed = false;
    this.context = new import0.ContentWritingsComponent(p0,p1,p2,p3,p4,p5,p6,p7);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentWritingsComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentWritingsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentWritingsComponent_0_4:Wrapper_ContentWritingsComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent_Host0,renderType_ContentWritingsComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentWritingsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentWritingsComponent_0_4 = new Wrapper_ContentWritingsComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.IntlService),this.parentInjector.get(import10.MetaService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.ContentService),this.parentInjector.get(import13.ActivatedRoute),this.parentInjector.get(import14.Location),this.parentInjector.get(import15.Router));
    this._appEl_0.initComponent(this._ContentWritingsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentWritingsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentWritingsComponent) && (0 === requestNodeIndex))) { return this._ContentWritingsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentWritingsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentWritingsComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentWritingsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentWritingsComponent_Host === (null as any))) { (renderType_ContentWritingsComponent_Host = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentWritingsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentWritingsComponentNgFactory:import17.ComponentFactory<import0.ContentWritingsComponent> = new import17.ComponentFactory<import0.ContentWritingsComponent>('ng-component',viewFactory_ContentWritingsComponent_Host0,import0.ContentWritingsComponent);
const styles_ContentWritingsComponent:any[] = ([] as any[]);
var renderType_ContentWritingsComponent:import2.RenderComponentType = (null as any);
class _View_ContentWritingsComponent0 extends import1.AppView<import0.ContentWritingsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import18.Wrapper_NgIf;
  _text_7:any;
  _el_8:any;
  _SearchableContentsComponent_8_3:import19.Wrapper_SearchableContentsComponent;
  _text_9:any;
  _el_10:any;
  _NgSwitch_10_3:import20.Wrapper_NgSwitch;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgSwitchCase_15_6:import20.Wrapper_NgSwitchCase;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _anchor_20:any;
  /*private*/ _appEl_20:import3.AppElement;
  _TemplateRef_20_5:any;
  _NgSwitchCase_20_6:import20.Wrapper_NgSwitchCase;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _anchor_25:any;
  /*private*/ _appEl_25:import3.AppElement;
  _TemplateRef_25_5:any;
  _NgSwitchCase_25_6:import20.Wrapper_NgSwitchCase;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _pipe_intl_0:import21.IntlPipe;
  _pipe_date_1:import22.DatePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent0,renderType_ContentWritingsComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_6 = new import3.AppElement(6,(null as any),this,this._anchor_6);
    this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6,viewFactory_ContentWritingsComponent1);
    this._NgIf_6_6 = new import18.Wrapper_NgIf(this._appEl_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray8(6,'context','writing','id','content-start','searchable-contents',''),(null as any));
    this._SearchableContentsComponent_8_3 = new import19.Wrapper_SearchableContentsComponent(this.parentInjector.get(import12.ContentService),this.parentInjector.get(import24.SearchService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import13.ActivatedRoute),this.parentInjector.get(import15.Router),this.parentInjector.get(import25.ElasticSearchService));
    this._text_9 = this.renderer.createText(this._el_8,'\n\n  ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_8,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._NgSwitch_10_3 = new import20.Wrapper_NgSwitch();
    this._text_11 = this.renderer.createText(this._el_10,'\n    ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n\n      ',(null as any));
    this._text_14 = this.renderer.createText(this._el_12,'\n      ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_15 = new import3.AppElement(15,12,this,this._anchor_15);
    this._TemplateRef_15_5 = new import23.TemplateRef_(this._appEl_15,viewFactory_ContentWritingsComponent3);
    this._NgSwitchCase_15_6 = new import20.Wrapper_NgSwitchCase(this._appEl_15.vcRef,this._TemplateRef_15_5,this._NgSwitch_10_3.context);
    this._text_16 = this.renderer.createText(this._el_12,'\n\n      ',(null as any));
    this._text_17 = this.renderer.createText(this._el_12,'\n      ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_12,'div',new import4.InlineArray2(2,'class','col-md-3 col-sm-4 sidebar writings-sidebar'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n\n        ',(null as any));
    this._anchor_20 = this.renderer.createTemplateAnchor(this._el_18,(null as any));
    this._appEl_20 = new import3.AppElement(20,18,this,this._anchor_20);
    this._TemplateRef_20_5 = new import23.TemplateRef_(this._appEl_20,viewFactory_ContentWritingsComponent4);
    this._NgSwitchCase_20_6 = new import20.Wrapper_NgSwitchCase(this._appEl_20.vcRef,this._TemplateRef_20_5,this._NgSwitch_10_3.context);
    this._text_21 = this.renderer.createText(this._el_18,'\n\n      ',(null as any));
    this._text_22 = this.renderer.createText(this._el_12,'\n      ',(null as any));
    this._text_23 = this.renderer.createText(this._el_12,'\n\n      ',(null as any));
    this._text_24 = this.renderer.createText(this._el_12,'\n      ',(null as any));
    this._anchor_25 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_25 = new import3.AppElement(25,12,this,this._anchor_25);
    this._TemplateRef_25_5 = new import23.TemplateRef_(this._appEl_25,viewFactory_ContentWritingsComponent5);
    this._NgSwitchCase_25_6 = new import20.Wrapper_NgSwitchCase(this._appEl_25.vcRef,this._TemplateRef_25_5,this._NgSwitch_10_3.context);
    this._text_26 = this.renderer.createText(this._el_12,'\n    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_10,'\n  ',(null as any));
    this._text_28 = this.renderer.createText(this._el_8,'\n',(null as any));
    this._text_29 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_intl_0 = new import21.IntlPipe();
    this._pipe_date_1 = new import22.DatePipe(this.parentInjector.get(import26.LOCALE_ID));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._anchor_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._anchor_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import27.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import23.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import28.NgSwitchCase) && (15 === requestNodeIndex))) { return this._NgSwitchCase_15_6.context; }
    if (((token === import23.TemplateRef) && (20 === requestNodeIndex))) { return this._TemplateRef_20_5; }
    if (((token === import28.NgSwitchCase) && (20 === requestNodeIndex))) { return this._NgSwitchCase_20_6.context; }
    if (((token === import23.TemplateRef) && (25 === requestNodeIndex))) { return this._TemplateRef_25_5; }
    if (((token === import28.NgSwitchCase) && (25 === requestNodeIndex))) { return this._NgSwitchCase_25_6.context; }
    if (((token === import28.NgSwitch) && ((10 <= requestNodeIndex) && (requestNodeIndex <= 27)))) { return this._NgSwitch_10_3.context; }
    if (((token === import29.SearchableContentsComponent) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._SearchableContentsComponent_8_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_6_0_0:any = this.context.currentLanguage;
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_8_0_0:any = 'writing';
    this._SearchableContentsComponent_8_3.check_context(currVal_8_0_0,throwOnChange,false);
    const currVal_8_0_1:any = this.context.pageSize;
    this._SearchableContentsComponent_8_3.check_pageSize(currVal_8_0_1,throwOnChange,false);
    const currVal_8_0_2:any = true;
    this._SearchableContentsComponent_8_3.check_active(currVal_8_0_2,throwOnChange,false);
    this._SearchableContentsComponent_8_3.detectChangesInInputProps(this,this._el_8,throwOnChange);
    const currVal_10_0_0:any = this._SearchableContentsComponent_8_3.context.loading;
    this._NgSwitch_10_3.check_ngSwitch(currVal_10_0_0,throwOnChange,false);
    this._NgSwitch_10_3.detectChangesInInputProps(this,this._el_10,throwOnChange);
    const currVal_15_0_0:any = true;
    this._NgSwitchCase_15_6.check_ngSwitchCase(currVal_15_0_0,throwOnChange,false);
    this._NgSwitchCase_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    const currVal_20_0_0:any = false;
    this._NgSwitchCase_20_6.check_ngSwitchCase(currVal_20_0_0,throwOnChange,false);
    this._NgSwitchCase_20_6.detectChangesInInputProps(this,this._anchor_20,throwOnChange);
    const currVal_25_0_0:any = false;
    this._NgSwitchCase_25_6.check_ngSwitchCase(currVal_25_0_0,throwOnChange,false);
    this._NgSwitchCase_25_6.detectChangesInInputProps(this,this._anchor_25,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchableContentsComponent_8_3.detectChangesInHostProps(this,this._el_8,throwOnChange);
    this._NgSwitch_10_3.detectChangesInHostProps(this,this._el_10,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentWritingsComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentWritingsComponent> {
  if ((renderType_ContentWritingsComponent === (null as any))) { (renderType_ContentWritingsComponent = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,styles_ContentWritingsComponent,{})); }
  return new _View_ContentWritingsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _anchor_16:any;
  /*private*/ _appEl_16:import3.AppElement;
  _TemplateRef_16_5:any;
  _NgIf_16_6:import18.Wrapper_NgIf;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  /*private*/ _expr_25:any;
  _pipe_intl_0_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent1,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_25 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'section',new import4.InlineArray2(2,'class','page-title page-title-small bg-gray'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','col-md-5 col-xs-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'h1',new import4.InlineArray2(2,'class','black-text'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','col-md-7 col-xs-12 breadcrumb text-uppercase'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'ul',new import4.InlineArray2(2,'class','breadcrumb-sub'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                    ',(null as any));
    this._anchor_16 = this.renderer.createTemplateAnchor(this._el_14,(null as any));
    this._appEl_16 = new import3.AppElement(16,14,this,this._anchor_16);
    this._TemplateRef_16_5 = new import23.TemplateRef_(this._appEl_16,viewFactory_ContentWritingsComponent2);
    this._NgIf_16_6 = new import18.Wrapper_NgIf(this._appEl_16.vcRef,this._TemplateRef_16_5);
    this._text_17 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._text_18 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_21 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_intl_0_0 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingsComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._anchor_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (16 === requestNodeIndex))) { return this._TemplateRef_16_5; }
    if (((token === import27.NgIf) && (16 === requestNodeIndex))) { return this._NgIf_16_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_16_0_0:any = this.parent.context.hasFilter;
    this._NgIf_16_6.check_ngIf(currVal_16_0_0,throwOnChange,false);
    this._NgIf_16_6.detectChangesInInputProps(this,this._anchor_16,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_25:any = import4.interpolate(1,'\n                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,(<_View_ContentWritingsComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.MENU.WRITINGS.LONG),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_9,currVal_25);
      this._expr_25 = currVal_25;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent2 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_intl_0_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent2,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_3 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._el_1 = import4.createRenderElement(this.renderer,this._el_0,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_1,'click',this.eventHandler(this._handle_click_1_0.bind(this)));
    this._pipe_intl_0_1 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingsComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_3:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,(<_View_ContentWritingsComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.MENU.WRITINGS.ALL),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_1_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_1_0:any = ((<any>this.parent.parent.context.utils.lLink('writings',this.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_1_0);
  }
}
function viewFactory_ContentWritingsComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent3 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LoadingIndicator_0_4:import30.Wrapper_LoadingIndicator;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent3,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'loading-indicator',new import4.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import30.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new import30.Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '#B6B6B6';
    this._LoadingIndicator_0_4.check_color(currVal_0_0_0,throwOnChange,false);
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent4 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _SearchFacetsComponent_0_4:import32.Wrapper_SearchFacetsComponent;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent4,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'search-facets',new import4.InlineArray4(4,'class','hidden-xs','target','/writings'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import32.viewFactory_SearchFacetsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchFacetsComponent_0_4 = new import32.Wrapper_SearchFacetsComponent(this.parent.parentInjector.get(import11.UtilsService),this.parent.parentInjector.get(import13.ActivatedRoute),this.parent.parentInjector.get(import15.Router),this.parent.parentInjector.get(import25.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n        ',(null as any));
    compView_0.create(this._SearchFacetsComponent_0_4.context,([] as any[]),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'onFilter',this.eventHandler(this._handle_onFilter_0_0.bind(this)));
    const subscription_0:any = this._SearchFacetsComponent_0_4.context.onFilter.subscribe(this.eventHandler(this._handle_onFilter_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.SearchFacetsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFacetsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = (<_View_ContentWritingsComponent0>this.parent)._SearchableContentsComponent_8_3.context.esAggregations;
    this._SearchFacetsComponent_0_4.check_esAggregations(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = (<_View_ContentWritingsComponent0>this.parent)._SearchableContentsComponent_8_3.context.aggFields.writing;
    this._SearchFacetsComponent_0_4.check_fields(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = (<_View_ContentWritingsComponent0>this.parent)._SearchableContentsComponent_8_3.context.esFilters;
    this._SearchFacetsComponent_0_4.check_esFilters(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchFacetsComponent_0_4.check_labels(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = this.parent.context.currentLanguage;
    this._SearchFacetsComponent_0_4.check_language(currVal_0_0_4,throwOnChange,false);
    const currVal_0_0_5:any = '/writings';
    this._SearchFacetsComponent_0_4.check_target(currVal_0_0_5,throwOnChange,false);
    this._SearchFacetsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFacetsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onFilter_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_ContentWritingsComponent0>this.parent)._SearchableContentsComponent_8_3.context.searchCallBack($event)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentWritingsComponent4(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _NgClass_3_3:import34.Wrapper_NgClass;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import18.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import3.AppElement;
  _TemplateRef_10_5:any;
  _NgSwitchCase_10_6:import20.Wrapper_NgSwitchCase;
  _text_11:any;
  _map_19:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent5,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._map_19 = import4.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'shorting-filter': p0,
        'shorting-nofilter': p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-md-9 col-sm-8 catalogue-content writings-content col-md-offset-1'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        \n        ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','shorting writings-shorting clearfix xs-no-margin col-xs-12'),(null as any));
    this._NgClass_3_3 = new import34.Wrapper_NgClass(this.parent.parentInjector.get(import35.IterableDiffers),this.parent.parentInjector.get(import36.KeyValueDiffers),new import37.ElementRef(this._el_3),this.renderer);
    this._text_4 = this.renderer.createText(this._el_3,'\n\n          ',(null as any));
    this._text_5 = this.renderer.createText(this._el_3,' \n          ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_6 = new import3.AppElement(6,3,this,this._anchor_6);
    this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6,viewFactory_ContentWritingsComponent6);
    this._NgIf_6_6 = new import18.Wrapper_NgIf(this._appEl_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_3,'\n\n        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n        \n        ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_10 = new import3.AppElement(10,0,this,this._anchor_10);
    this._TemplateRef_10_5 = new import23.TemplateRef_(this._appEl_10,viewFactory_ContentWritingsComponent7);
    this._NgSwitchCase_10_6 = new import20.Wrapper_NgSwitchCase(this._appEl_10.vcRef,this._TemplateRef_10_5,(<_View_ContentWritingsComponent0>this.parent)._NgSwitch_10_3.context);
    this._text_11 = this.renderer.createText(this._el_0,'\n      ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._anchor_10,
      this._text_11
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import27.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import38.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgClass_3_3.context; }
    if (((token === import23.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import28.NgSwitchCase) && (10 === requestNodeIndex))) { return this._NgSwitchCase_10_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = 'shorting writings-shorting clearfix xs-no-margin col-xs-12';
    this._NgClass_3_3.check_klass(currVal_3_0_0,throwOnChange,false);
    const currVal_3_0_1:any = this._map_19(this.parent.context.hasFilter,!this.parent.context.hasFilter);
    this._NgClass_3_3.check_ngClass(currVal_3_0_1,throwOnChange,false);
    this._NgClass_3_3.detectChangesInInputProps(this,this._el_3,throwOnChange);
    const currVal_6_0_0:any = this.parent.context.hasFilter;
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_10_0_0:any = false;
    this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0,throwOnChange,false);
    this._NgSwitchCase_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_3_3.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent5(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  /*private*/ _appEl_3:import3.AppElement;
  _SearchFilterComponent_3_4:import39.Wrapper_SearchFilterComponent;
  _text_4:any;
  _text_5:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent6,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-xs-12 grid-nav'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'search-filters',new import4.InlineArray2(2,'class','search-filters'),(null as any));
    this._appEl_3 = new import3.AppElement(3,0,this,this._el_3);
    var compView_3:any = import39.viewFactory_SearchFilterComponent0(this.viewUtils,this.injector(3),this._appEl_3);
    this._SearchFilterComponent_3_4 = new import39.Wrapper_SearchFilterComponent(this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import15.Router),this.parent.parent.parentInjector.get(import13.ActivatedRoute),this.parent.parent.parentInjector.get(import25.ElasticSearchService));
    this._appEl_3.initComponent(this._SearchFilterComponent_3_4.context,([] as any[]),compView_3);
    this._text_4 = this.renderer.createText((null as any),'\n            ',(null as any));
    compView_3.create(this._SearchFilterComponent_3_4.context,([] as any[]),(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n\n          ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.SearchFilterComponent) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 4)))) { return this._SearchFilterComponent_3_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = (<_View_ContentWritingsComponent0>this.parent.parent)._SearchableContentsComponent_8_3.context.esQuery;
    this._SearchFilterComponent_3_4.check_esQuery(currVal_3_0_0,throwOnChange,false);
    const currVal_3_0_1:any = (<_View_ContentWritingsComponent0>this.parent.parent)._SearchableContentsComponent_8_3.context.esFilters;
    this._SearchFilterComponent_3_4.check_esFilters(currVal_3_0_1,throwOnChange,false);
    const currVal_3_0_2:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CATALOGUE.FILTERS)[this.parent.parent.context.currentLanguage];
    this._SearchFilterComponent_3_4.check_title(currVal_3_0_2,throwOnChange,false);
    const currVal_3_0_3:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchFilterComponent_3_4.check_labels(currVal_3_0_3,throwOnChange,false);
    const currVal_3_0_4:any = this.parent.parent.context.currentLanguage;
    this._SearchFilterComponent_3_4.check_language(currVal_3_0_4,throwOnChange,false);
    this._SearchFilterComponent_3_4.detectChangesInInputProps(this,this._el_3,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFilterComponent_3_4.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent6(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import3.AppElement;
  _TemplateRef_3_5:any;
  _NgFor_3_6:import41.Wrapper_NgFor;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgSwitchCase_6_6:import20.Wrapper_NgSwitchCase;
  _text_7:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent7,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n          ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_3 = new import3.AppElement(3,0,this,this._anchor_3);
    this._TemplateRef_3_5 = new import23.TemplateRef_(this._appEl_3,viewFactory_ContentWritingsComponent8);
    this._NgFor_3_6 = new import41.Wrapper_NgFor(this._appEl_3.vcRef,this._TemplateRef_3_5,this.parent.parent.parentInjector.get(import35.IterableDiffers),this.parent.parent.ref);
    this._text_4 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_6 = new import3.AppElement(6,0,this,this._anchor_6);
    this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6,viewFactory_ContentWritingsComponent11);
    this._NgSwitchCase_6_6 = new import20.Wrapper_NgSwitchCase(this._appEl_6.vcRef,this._TemplateRef_6_5,(<_View_ContentWritingsComponent0>this.parent.parent)._NgSwitch_10_3.context);
    this._text_7 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import42.NgFor) && (3 === requestNodeIndex))) { return this._NgFor_3_6.context; }
    if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import28.NgSwitchCase) && (6 === requestNodeIndex))) { return this._NgSwitchCase_6_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = (<_View_ContentWritingsComponent0>this.parent.parent)._SearchableContentsComponent_8_3.context.dbContents;
    this._NgFor_3_6.check_ngForOf(currVal_3_0_0,throwOnChange,false);
    this._NgFor_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    const currVal_6_0_0:any = false;
    this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0,throwOnChange,false);
    this._NgSwitchCase_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingsComponent7(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _appEl_8:import3.AppElement;
  _TemplateRef_8_5:any;
  _NgFor_8_6:import41.Wrapper_NgFor;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  /*private*/ _expr_27:any;
  /*private*/ _expr_28:any;
  _pipe_date_1_0:any;
  /*private*/ _expr_30:any;
  /*private*/ _expr_31:any;
  /*private*/ _expr_32:any;
  _pipe_intl_0_2:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent8,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_27 = import7.UNINITIALIZED;
    this._expr_28 = import7.UNINITIALIZED;
    this._expr_30 = import7.UNINITIALIZED;
    this._expr_31 = import7.UNINITIALIZED;
    this._expr_32 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-md-12 writing-listing blog-listing blog-listing-classic'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','blog-details writing-details'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','blog-date'),(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_4,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._appEl_8 = new import3.AppElement(8,4,this,this._anchor_8);
    this._TemplateRef_8_5 = new import23.TemplateRef_(this._appEl_8,viewFactory_ContentWritingsComponent9);
    this._NgFor_8_6 = new import41.Wrapper_NgFor(this._appEl_8.vcRef,this._TemplateRef_8_5,this.parent.parent.parent.parentInjector.get(import35.IterableDiffers),this.parent.parent.parent.ref);
    this._text_9 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','blog-title'),(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_11,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','writing-summary'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','separator-line bg-black no-margin-lr margin-two'),(null as any));
    this._text_19 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','writing-read-more pointer highlight-button btn btn-small xs-no-margin-bottom'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n            \n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this._pipe_date_1_0 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_date_1.transform.bind((<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_date_1));
    var disposable_1:Function = this.renderer.listen(this._el_12,'click',this.eventHandler(this._handle_click_12_0.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_20,'click',this.eventHandler(this._handle_click_20_0.bind(this)));
    this._pipe_intl_0_2 = import4.pureProxy2((<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import42.NgFor) && (8 === requestNodeIndex))) { return this._NgFor_8_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_8_0_0:any = this.context.$implicit.tags;
    this._NgFor_8_6.check_ngForOf(currVal_8_0_0,throwOnChange,false);
    this._NgFor_8_6.detectChangesInInputProps(this,this._anchor_8,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_27:any = import4.interpolate(1,'\n                  ',this.context.$implicit.author,'');
    if (import4.checkBinding(throwOnChange,this._expr_27,currVal_27)) {
      this.renderer.setText(this._text_6,currVal_27);
      this._expr_27 = currVal_27;
    }
    valUnwrapper.reset();
    const currVal_28:any = import4.interpolate(1,' | ',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_1_0,(<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_date_1.transform)(this.context.$implicit.date,'yyyy')),' | \n                  ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_7,currVal_28);
      this._expr_28 = currVal_28;
    }
    const currVal_30:any = import4.interpolate(1,'\n                ',this.context.$implicit.title[this.parent.parent.parent.context.currentLanguage],'');
    if (import4.checkBinding(throwOnChange,this._expr_30,currVal_30)) {
      this.renderer.setText(this._text_13,currVal_30);
      this._expr_30 = currVal_30;
    }
    const currVal_31:any = import4.interpolate(1,'',this.context.$implicit.summary[this.parent.parent.parent.context.currentLanguage],'');
    if (import4.checkBinding(throwOnChange,this._expr_31,currVal_31)) {
      this.renderer.setText(this._text_16,currVal_31);
      this._expr_31 = currVal_31;
    }
    valUnwrapper.reset();
    const currVal_32:any = import4.interpolate(1,'\n                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2,(<_View_ContentWritingsComponent0>this.parent.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.context.intl.data.WRITING.FULL_TEXT_GO),this.parent.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_32,currVal_32))) {
      this.renderer.setText(this._text_21,currVal_32);
      this._expr_32 = currVal_32;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(('writings?f=author~' + this.context.$implicit.author),this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_5_0);
  }
  private _handle_click_12_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_12_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(('writing/' + this.context.$implicit.url),this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_12_0);
  }
  private _handle_click_20_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(('writing/' + this.context.$implicit.url),this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_20_0);
  }
}
function viewFactory_ContentWritingsComponent8(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import18.Wrapper_NgIf;
  _text_5:any;
  /*private*/ _expr_9:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent9,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_9 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_4 = new import3.AppElement(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import23.TemplateRef_(this._appEl_4,viewFactory_ContentWritingsComponent10);
    this._NgIf_4_6 = new import18.Wrapper_NgIf(this._appEl_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import27.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = ((this.context.index + 1) < this.parent.context.$implicit.tags.length);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_9:any = import4.interpolate(1,'\n                    ',(((this.parent.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.parent.context.intl.data.COMMON.TAXONOMY.tag.VALUES)[this.context.$implicit]? ((this.parent.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.parent.context.intl.data.COMMON.TAXONOMY.tag.VALUES)[this.context.$implicit][this.parent.parent.parent.parent.context.currentLanguage]: this.context.$implicit),'');
    if (import4.checkBinding(throwOnChange,this._expr_9,currVal_9)) {
      this.renderer.setText(this._text_3,currVal_9);
      this._expr_9 = currVal_9;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.parent.context.utils.lLink(('writings?f=tag~' + this.context.$implicit),this.parent.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_ContentWritingsComponent9(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent9(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent10,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,', ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentWritingsComponent10(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent10(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingsComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _PaginationComponent_2_4:import43.Wrapper_PaginationComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingsComponent11,renderType_ContentWritingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','pagination margin-two no-margin-bottom'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'ng-pagination',new import4.InlineArray16(10,'first-text','«','last-text','»','next-text','<img src=\'/data/images/arrow-next-small.png\'/>','previous-text','<img src=\'/data/images/arrow-pre-small.png\'/>','style','cursor: pointer'),(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._el_2);
    var compView_2:any = import43.viewFactory_PaginationComponent0(this.viewUtils,this.injector(2),this._appEl_2);
    this._PaginationComponent_2_4 = new import43.Wrapper_PaginationComponent();
    this._appEl_2.initComponent(this._PaginationComponent_2_4.context,([] as any[]),compView_2);
    this._text_3 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_2.create(this._PaginationComponent_2_4.context,([] as any[]),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'pageChange',this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    const subscription_0:any = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import44.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._PaginationComponent_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = '<img src=\'/data/images/arrow-pre-small.png\'/>';
    this._PaginationComponent_2_4.check_previousText(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = '<img src=\'/data/images/arrow-next-small.png\'/>';
    this._PaginationComponent_2_4.check_nextText(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = '«';
    this._PaginationComponent_2_4.check_firstText(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = '»';
    this._PaginationComponent_2_4.check_lastText(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = (<_View_ContentWritingsComponent0>this.parent.parent.parent)._SearchableContentsComponent_8_3.context.esContents['total'];
    this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parent.parent.parent.context.currentPage;
    this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parent.parent.parent.context.pageSize;
    this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6,throwOnChange,false);
    this._PaginationComponent_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._PaginationComponent_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_pageChange_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.context.onPageChange($event,'writings')) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_ContentWritingsComponent11(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingsComponent11(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-writings.component.ngfactory.ts